import { render, staticRenderFns } from "./AdmittedPremiumTableHistory.vue?vue&type=template&id=be2e49e2&scoped=true&"
import script from "./AdmittedPremiumTableHistory.vue?vue&type=script&lang=js&"
export * from "./AdmittedPremiumTableHistory.vue?vue&type=script&lang=js&"
import style0 from "./AdmittedPremiumTableHistory.vue?vue&type=style&index=0&id=be2e49e2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2e49e2",
  null
  
)

export default component.exports